import { render, staticRenderFns } from "./ContentCarouselItem.vue?vue&type=template&id=05efccdc&scoped=true"
import script from "./ContentCarouselItem.vue?vue&type=script&lang=ts"
export * from "./ContentCarouselItem.vue?vue&type=script&lang=ts"
import style0 from "./ContentCarouselItem.vue?vue&type=style&index=0&id=05efccdc&prod&lang=scss"
import style1 from "./ContentCarouselItem.vue?vue&type=style&index=1&id=05efccdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05efccdc",
  null
  
)

export default component.exports